import { useState, useEffect, MutableRefObject, useLayoutEffect, useRef } from 'react';
import dayjs from 'dayjs';
import { DatePosition, DateRange } from '../helpers/common-types';
import { throttle, debounce } from 'lodash';
import { useAfterPaintEffect, useAppSelector } from './hooks';
import { DATE_FORMAT, getMonthsInRange } from '../helpers/date-helpers';

export enum NavigationDirection {
    NEXT = "next",
    PREVIOUS = "previous"
}

export const useIsDirectionOutOfRange = () => {
    const today = useAppSelector(state => state.calendar.todaysDate);
    const lastDate = useAppSelector(state => state.settings.lastDate);
    const allMonths = getMonthsInRange(today, lastDate);
    const currentDate = useAppSelector(state => state.calendar.currentDate);
    const currentMonth = dayjs(currentDate).month();
    const testDirections = [NavigationDirection.NEXT, NavigationDirection.PREVIOUS].map(direction => {
        const targetMonth = dayjs(currentDate).month((direction === NavigationDirection.NEXT) ? currentMonth + 1 : currentMonth - 1).startOf('month').format(DATE_FORMAT);
        const match = allMonths.filter(monthData => {
            return targetMonth == monthData.month;
        });
        return match.length == 0;
    });
    return testDirections;
}